import { render, staticRenderFns } from "./EsyLabel.vue?vue&type=template&id=396e467f&scoped=true"
import script from "./EsyLabel.vue?vue&type=script&lang=ts"
export * from "./EsyLabel.vue?vue&type=script&lang=ts"
import style0 from "./EsyLabel.vue?vue&type=style&index=0&id=396e467f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e467f",
  null
  
)

export default component.exports